import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';
import { CrlBulkAction } from '../../../../models';

/**
 * Batch toolbar shown while bulk-actions selection mode is active (REQ-11,
 * SHELL ONLY).
 *
 * Renders the selected-item count and the three batch actions — Mark Finished,
 * Mark N/A, Reassign — plus a Done control that exits selection mode. This is a
 * presentational shell: it emits the chosen `CrlBulkAction` (or `done`); NO real
 * mutation is wired yet (the container's handler is a TODO). The action buttons
 * are disabled when nothing is selected so the dead-end state reads clearly.
 */
@Component({
  selector: 'cxp-crl-bulk-action-bar',
  templateUrl: './crl-bulk-action-bar.component.html',
  styleUrls: ['./crl-bulk-action-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class CrlBulkActionBarComponent {
  /** Number of currently-selected rows. */
  readonly selectedCount = input<number>(0);

  /** Emits the chosen batch action (shell — container wires the real op later). */
  readonly action = output<CrlBulkAction>();
  /** Emits when the user exits selection mode. */
  readonly done = output<void>();

  protected readonly bulkAction = CrlBulkAction;
  protected readonly hasSelection = computed(() => this.selectedCount() > 0);

  onAction(action: CrlBulkAction): void {
    this.action.emit(action);
  }
}
